import { mapListingAction } from './mapListingAction';
import { APIListingItem } from '../types';

/**
 * Maps over any API Listing's actions and passes through to the action formatter. Guarantees an array returned.
 */
export function mapListingActions(apiListing: APIListingItem) {
  return (apiListing.actions ?? [])
    .map((action) => mapListingAction(action, apiListing))
    .filter((action) => Boolean(action));
}
